import React from 'react';

import { QueueState } from '../../../components/queue-state';
import { QueueActions } from '../components/queue-actions';
import { BusinessHours } from '../components/business-hours/index';

import { useDispatch, useSelector } from 'react-redux';

import { sendQueueAction } from '../../../features/queue-settings';
import { getQueueSelector } from '../../../selectors/queue-selectors';
import { BaseSettings } from '../components/base-settings';

import { t } from '../../../locales/i18n';
import { Segment } from '../../../components/segment';
import { RootState } from '../../../root-reducer';
import { useParams } from 'react-router-dom';
import {
  HeroContainer,
  AppContent
} from '../../../components/layout/layout-components';
import styled from 'styled-components';

const Container = styled.section``;

export interface QueueSettingsPageProps {}

export function QueueSettingsPage(props: QueueSettingsPageProps) {
  const dispatch = useDispatch();
  const { id: queueId } = useParams();
  const { queue } = useSelector((s: RootState) => ({
    queue: getQueueSelector(queueId)(s.queues.connectedQueues)
  }));
  const onQueueAction = (queueId: string, actionName: string) =>
    dispatch(sendQueueAction(queueId, actionName));
  if (!queue) {
    return null;
  }
  return (
    <HeroContainer minWidth="680px">
      <h2>{t('queueSettingsPage.header', queue)}</h2>
      <h3>
        <QueueState queue={queue} showDetail />
      </h3>
      <AppContent>
        <Segment>
          <QueueActions
            queue={queue}
            onConfirm={(actionName) => onQueueAction(queueId || '', actionName)}
          />
        </Segment>
        <Segment>
          <BaseSettings queue={queue} />
        </Segment>
        <Segment>
          <h3>{t('queueSettingsPage.calendarSectionHeader')}</h3>
          <BusinessHours
            id={queue.id}
            businessHours={queue.businessHours || []}
          />
        </Segment>
      </AppContent>
    </HeroContainer>
  );
}
